<template>
  <span class="cabinet-status" :class="`cabinet-status--${tone}`">{{ label }}</span>
</template>

<script>
export default {
  name: 'CabinetStatus',
  props: { status: { type: [Object, String], default: () => ({}) } },
  computed: {
    code() { return typeof this.status === 'string' ? this.status : this.status.code },
    label() { return this.$choice('statuses', this.status, this.$t('common.unknown')) },
    tone() {
      if (['submitted', 'requested', 'pending'].includes(this.code)) return 'warning'
      if (['in_review', 'approved', 'active'].includes(this.code)) return 'info'
      if (['reviewed', 'repaid', 'fully_paid', 'completed'].includes(this.code)) return 'success'
      if (['rejected', 'cancelled', 'abandoned'].includes(this.code)) return 'danger'
      return 'neutral'
    },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-status
  display: inline-flex
  align-items: center
  min-height: 25px
  padding: 4px 9px
  border-radius: 13px
  background: #ececec
  color: #6b7280
  font-size: 11px
  font-weight: 700
  letter-spacing: .02em

.cabinet-status--warning
  background: #fff4d8
  color: #b96f00
.cabinet-status--info
  background: #e8f0ff
  color: #2563eb
.cabinet-status--success
  background: #e8f7eb
  color: #16803a
.cabinet-status--danger
  background: #ffebe7
  color: #b74236
</style>
